// Rào lỗi: 1 màn bị lỗi khi vẽ thì chỉ màn đó hiện thông báo + nút thử lại — thanh trên và các màn khác vẫn dùng được
// (không trắng cả trang). Đổi màn ⇒ khoaReset đổi ⇒ rào tự gỡ lỗi cũ.
import { Component, type ReactNode } from "react";

interface Props { children: ReactNode; khoaReset?: string }
interface State { loi: Error | null }

export class RaoLoi extends Component<Props, State> {
  state: State = { loi: null };

  static getDerivedStateFromError(loi: Error): State { return { loi }; }

  componentDidUpdate(truoc: Props) {
    if (truoc.khoaReset !== this.props.khoaReset && this.state.loi) this.setState({ loi: null });
  }

  componentDidCatch(loi: Error) {
    console.error("Lỗi giao diện:", loi.message);
  }

  render() {
    if (!this.state.loi) return this.props.children;
    const taiMa = /dynamically imported module|Loading chunk|Importing a module script failed/i.test(this.state.loi.message);
    return (
      <section className="screen">
        <div className="empty">
          <div style={{ display: "grid", gap: 10, justifyItems: "center" }}>
            <h3>{taiMa ? "Có bản web mới — cần tải lại trang" : "Màn này gặp lỗi"}</h3>
            <p style={{ margin: 0 }} className="small">{taiMa ? "Bấm tải lại để dùng bản mới nhất." : this.state.loi.message}</p>
            <button type="button" className="btn primary" onClick={() => (taiMa ? window.location.reload() : this.setState({ loi: null }))}>
              {taiMa ? "Tải lại trang" : "Thử lại"}
            </button>
          </div>
        </div>
      </section>
    );
  }
}
